import { Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import DeleteIcon from "@material-ui/icons/Delete";
import { useGlobalStyles } from "../../style/GlobalStyle";
import EditIcon from "@material-ui/icons/Edit";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import { Model } from "../../model/setup-sequelize/Model";

const useStyles = makeStyles((theme) => ({
	root: {
		// height: 200,
		margin: 10,
		width: 200,
		border: `1px solid ${theme.palette.primary.main}`,
	},
	header: {
		background: theme.palette.primary.main,
		height: 30,
		width: "100%",
		color: "white",
		paddingLeft: 5,
	},
	iconAction: {
		color: "white",
	},
	numberOrder: {
		padding: 2,
		border: `0.5px solid ${theme.palette.primary.main}`,
	},
	nameColumn: {
		flex: 1,
		padding: 2,
		border: `0.5px solid ${theme.palette.primary.main}`,
	},
}));

type Props = {
	item: Model;
	onEdit: (item: Model) => void;
	onDelete: (item: Model) => void;
};
export default function TableDatabaseItem(props: Props) {
	const classes = useStyles();
	const globalStyles = useGlobalStyles();
	return (
		<Grid item justify="center">
			<Grid
				container
				className={clsx(classes.root)}
				alignItems="flex-start"
			>
				<Grid
					className={clsx(classes.header)}
					container
					alignContent="center"
				>
					<Grid xs={8}>
						<Typography>{props.item.name || ""}</Typography>
					</Grid>
					<Grid xs={4} container direction="row">
						<IconButton aria-label="delete" size="small" onClick = {(e)=> {props.onDelete(props.item)}}>
							<DeleteIcon
								fontSize="small"
								className={clsx(classes.iconAction)}
							/>
						</IconButton>
						<IconButton aria-label="delete" size="small" onClick = {(e)=> {props.onEdit(props.item)}}>
							<EditIcon
								fontSize="small"
								className={clsx(classes.iconAction)}
							/>
						</IconButton>
					</Grid>
				</Grid>
				<Grid container>
					{props.item.fields?.map((item, value) => {
						return (
							<Grid container>
								<Grid className={clsx(classes.numberOrder)} xs={2}>
									{item.primaryKey ? <VpnKeyIcon fontSize = "small" color = "secondary"/> : <Typography>{value + 1}</Typography>}
								</Grid>
								<Grid className={clsx(classes.nameColumn)} xs={10}>
									<Typography>{item.name}</Typography>
								</Grid>
							</Grid>
						);
					})}
				</Grid>
			</Grid>
		</Grid>
	);
}
